import React, { useEffect } from 'react'
import styles from "./Profile.module.scss"
import FileUploadButton from 'components/shared/fileUploadButton/FileUploadButton'
import { Form, useFormikContext } from 'formik'
import { TextField } from '@mui/material'
import Button from 'components/shared/button/Button'
import { getUserData } from 'utils/utils';
import { UPLOAD, USER } from 'services/apiEndpoints';
import { useFormHandler } from '../hierarchy/hooks/useFormHandler';
import { privatePost } from 'services/privateRequest';
import DeleteIcon from "@mui/icons-material/Delete";
import { useForm } from 'react-hook-form';
import imageCompression from 'browser-image-compression';


const ProfileForm = () => {
    const { getDetails } = useFormHandler();
    const id = getUserData("userId");
    const { control } = useForm();

    const formik = useFormikContext();

    const handleFileChange = async (file, setIsLoading) => {
        setIsLoading({ loading: true, percent: 0 }); // Start with loading true and 0% progress
        const baseURL = process.env.REACT_APP_API_BASE_URL;

        const options = {
            maxSizeMB: 0.7,
            maxWidthOrHeight: 800,
            useWebWorker: true,
            alwaysKeepResolution: true,
        }

        try {
            const compressedFile = await imageCompression(file, options);
            const compressedBlob = new Blob([compressedFile], { type: file.type });
            const finalCompressedFile = new File([compressedBlob], file.name, { type: file.type });

            let formData = new FormData();
            formData.append("file", finalCompressedFile);

            const response = await privatePost(UPLOAD, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setIsLoading((prevState) => ({ ...prevState, percent })); // Update percent
                        }
                    }
                });
            if (!response?.success) {
                setIsLoading((prevState) => ({ ...prevState, isError: true })); // Set loading to false and percent to 100% when done
            }
            const url = `${baseURL}/uploads/${response.data.data[0]?.filename}`
            formik.setValues((prevValues) => ({
                ...prevValues,
                userProfile: url,
            }));

        } catch (error) {
            console.error("Error fetching form data:", error);
        } finally {
            setIsLoading({ loading: false, percent: 100 }); // Set loading to false and percent to 100% when done
        }
    };

    useEffect(() => {
        if (id) {
            (async () => {
                const response = await getDetails(USER, id);

                const formValues = {
                    firstName: response?.firstName,
                    lastName: response?.lastName,
                    phone: response?.mobileNumber,
                    email: response?.email,
                    userProfile: response?.userProfile
                };
                formik.resetForm({ values: { ...formValues } });
            })();
        }
    }, []);


    return (
        <>
            <Form onSubmit={(e) => {
                e.preventDefault();
                if (formik.dirty) {
                    formik.handleSubmit();
                } else {
                    console.log("No changes to update.");
                }
            }}>
                <div className={styles?.form}>
                    <div className={styles?.formBody}>
                        <div>
                            <TextField
                                variant="filled"
                                onChange={formik.handleChange}
                                value={formik.values.firstName}
                                onBlur={formik.handleBlur}
                                name="firstName"
                                size="small"
                                sx={{
                                    margin: "5px 0px !important",
                                    "& .MuiFormHelperText-root": {
                                        marginLeft: "0px",
                                    },
                                }}
                                margin="normal"
                                label="Enter First Name"
                                error={Boolean(formik.errors.firstName && formik.touched.firstName)}
                                helperText={
                                    formik.errors.firstName &&
                                    formik.touched.firstName &&
                                    String(formik.errors.firstName)
                                }
                                fullWidth
                            />

                        </div>
                        <div>
                            <TextField
                                variant="filled"
                                onChange={formik.handleChange}
                                value={formik.values.lastName}
                                onBlur={formik.handleBlur}
                                name="lastName"
                                size="small"
                                sx={{
                                    margin: "5px 0px !important",
                                    "& .MuiFormHelperText-root": {
                                        marginLeft: "0px",
                                    },
                                }}
                                margin="normal"
                                label="Enter Last Name"
                                error={Boolean(formik.errors.lastName && formik.touched.lastName)}
                                helperText={
                                    formik.errors.lastName &&
                                    formik.touched.lastName &&
                                    String(formik.errors.lastName)
                                }
                                fullWidth
                            />

                        </div>
                        <div>
                            <TextField
                                variant="filled"
                                disabled={true}
                                onChange={formik.handleChange}
                                value={formik.values.email}
                                onBlur={formik.handleBlur}
                                name="email"
                                size="small"
                                sx={{
                                    margin: "5px 0px !important",
                                    "& .MuiFormHelperText-root": {
                                        marginLeft: "0px",
                                    },
                                }}
                                margin="normal"
                                label="Enter Email"
                                error={Boolean(formik.errors.email && formik.touched.email)}
                                helperText={
                                    formik.errors.email &&
                                    formik.touched.email &&
                                    String(formik.errors.email)
                                }
                                fullWidth
                            />

                        </div>
                        <div>
                            <TextField
                                variant="filled"
                                onChange={formik.handleChange}
                                value={formik.values.phone}
                                onBlur={formik.handleBlur}
                                name="phone"
                                size="small"
                                sx={{
                                    margin: "5px 0px !important",
                                    "& .MuiFormHelperText-root": {
                                        marginLeft: "0px",
                                    },
                                }}
                                margin="normal"
                                label="Enter Phone"
                                error={Boolean(formik.errors.phone && formik.touched.phone)}
                                helperText={
                                    formik.errors.phone &&
                                    formik.touched.phone &&
                                    String(formik.errors.phone)
                                }
                                fullWidth
                            />

                        </div>
                        {
                            // !formik.values.userProfile ? (
                            //     <div className={combineClasses(style?.fileUploadContainer)}>
                            //     {/* <div className={combineClasses(style?.fileUploadContainer)}>
                            //         <input
                            //             type="file"
                            //             id={"ProfileUpload"}
                            //             accept='png, .jpg, .jpeg, .webp, .bmp, .tiff, .ico, .heic'
                            //             onChange={handleImageChange}
                            //             className={style?.fileInput}
                            //         />
                            //         <label htmlFor='ProfileUpload' className={style?.fileLabel}>
                            //             <UploadIcon width={10} height={16} />
                            //             <span>Change Profile Photo</span>
                            //         </label>
                            //         {/* {error && <p className={style?.errorMessage}>{error.message}</p>} 
                            //     </div> */}
                            //     <FormikControl
                            //                                 multiple={true}
                            //                                 name="media"
                            //                                 control="uploadMultiple"
                            //                                 placeholder="Upload files"
                            //                                 accept='png, .jpg, .jpeg, .webp, .bmp, .tiff, .ico, .heic'
                            //                                 newLabel={
                            //                                     "Drag or click to upload attachments"
                            //                                 }
                            //                                 onChange={(e) => {
                            //                                     // handleImageChange(e)
                            //                                     // Handle the file selection in Formik state
                            //                                     handleInputChange(
                            //                                         e,
                            //                                         formik.setFieldValue,
                            //                                         formik.values.media
                            //                                     );
                            //                                 }}
                            //                             />
                            //                         </div>
                            // ) : (
                            //     <div className={styles.imageContainer}>
                            //         <img width= "90px" height= "60px"  src={formik.values.userProfile} alt="" srcset="" />
                            //         <div
                            //                                                     className={styles.cancelIcon}
                            //                                                     onClick={(event) => {
                            //                                                         event.preventDefault();
                            //                                                         event.stopPropagation();
                            //                                                         formik.setFieldValue("userProfile" , "")
                            //                                                     }}
                            //                                                 >
                            //                                                     <DeleteIcon sx={{ width: "20px", height: "20px" }} />
                            //                                                 </div>
                            //     </div>

                            // )    
                        }
                        <div className={styles?.formField}>
                            <div className={styles.imageContainer}>
                                {formik?.values?.userProfile ? (
                                    <div className={styles.imageWrapper} >
                                        <img width={100} height={80} src={formik?.values?.userProfile} alt="" />
                                        <div
                                            className={styles.cancelIcon}
                                            onClick={(event) => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                formik.setFieldValue("userProfile", "")
                                            }}
                                        >
                                            <DeleteIcon sx={{ width: "20px", height: "20px" }} />
                                        </div>
                                    </div>
                                ) : (
                                    <FileUploadButton
                                        name="mediaFile"
                                        control={control}
                                        onFileChange={handleFileChange}
                                    />

                                )
                                }
                            </div>

                        </div>



                        {/* <div>
                            <TextField
                                variant="filled"
                                onChange={formik.handleChange}
                                value={formik.values.language}
                                onBlur={formik.handleBlur}
                                name="language"
                                size="small"
                                sx={{
                                    margin: "5px 0px !important",
                                    "& .MuiFormHelperText-root": {
                                        marginLeft: "0px",
                                    },
                                }}
                                margin="normal"
                                label="Enter Language"
                                error={Boolean(formik.errors.language && formik.touched.language)}
                                helperText={
                                    formik.errors.language &&
                                    formik.touched.language &&
                                    String(formik.errors.language)
                                }
                                fullWidth
                            />

                        </div> */}
                        <div>
                            <Button type="submit" disabled={formik.isSubmitting || !formik.dirty}>
                                {formik.isSubmitting ? "Processing" : "Update"}
                            </Button>
                        </div>
                    </div>

                </div >
            </Form >

        </>
    )
}

export default ProfileForm